import React, { useContext } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { ThemeContext } from '../../context/ThemeContext';
import { getContrastColor } from '../../utils/colorUtils';
import { LEGAL_DOCS, LEGAL_VERSION } from './legalContent';
import {
  PageWrapper, Container, BackBtn, DocTitle, DocVersion,
  Section, SectionTitle, SectionText,
} from './LegalPage.styles';

export default function LegalPage() {
  const { doc }    = useParams();
  const navigate   = useNavigate();
  const { theme }  = useContext(ThemeContext);

  const documento = LEGAL_DOCS[doc];
  if (!documento) return <Navigate to="/404" replace />;

  const bg    = theme.background || '#000';
  const acc   = theme.accent     || '#667eea';
  const color = getContrastColor(bg);

  return (
    <PageWrapper bg={bg}>
      <Container>
        <BackBtn accent={acc} onClick={() => navigate(-1)}>← Volver</BackBtn>

        <DocTitle color={color}>{documento.titulo}</DocTitle>
        <DocVersion color={color}>Versión {LEGAL_VERSION} — Mayo 2026 · Borrador pendiente de validación jurídica</DocVersion>

        {documento.secciones.map((sec, i) => (
          <Section key={i}>
            <SectionTitle accent={acc}>{sec.titulo}</SectionTitle>
            <SectionText color={color}>{sec.texto}</SectionText>
          </Section>
        ))}
      </Container>
    </PageWrapper>
  );
}
